// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14ysh","label":"styles_label__1cDJr"};